<label class="card-selectable mb-0" [attr.for]="inputID">
  <div class="row gx-2">
    <div class="col">
      @if (inputElem().content?.title) {
        <p class="text-secondary mb-2"><b [translate]="inputElem()?.content.title"></b></p>
      }
      <div class="mb-3">
        <mwe-product-icons [categories]="inputElem()?.content.categories" size="2xl" textNodeType="p" />
      </div>
      @if (inputElem()?.content.address) {
        <p class="mb-0">{{ postCodeAndStreet() }}</p>
      }
      @if (inputElem()?.radioValue) {
        <p>
          <b>{{ 'shared.accountNumberLabel' | translate }}:</b>
          {{ inputElem()?.radioValue }}
        </p>
      }
      @if (inputElem().content?.after) {
        <p>{{ inputElem().content?.after | translate }}</p>
      }
    </div>
    <div class="col-auto">
      <input
        [attr.data-test]="'form-input-' + inputElem()?.name"
        [attr.id]="inputID"
        [name]="inputElem.name"
        [attr.name]="inputElem.name"
        [formControl]="control()"
        [ngClass]="{
          'is-invalid': control()?.errors && !control()?.pristine,
          'form-check-readonly': isLoading() || inputElem()?.isReadonly,
        }"
        class="form-check-input"
        type="radio"
        [value]="inputElem().radioValue"
        [attr.aria-describedby]="ariaDescribedBy"
        [attr.aria-invalid]="!isValid"
        [required]="isRequired || null"
        mweClickPreventDefault
        [ignorePreventClickDefault]="!inputElem().isReadonly"
      />
    </div>
  </div>
</label>
